import CryptoJS from "crypto-js";
import {nanoid} from "nanoid";
import {Toast} from "vant";
import axios from "axios";
import {getLocalStorageForUser, removeLocalStorageForUser, setLocalStorageForUser} from "./localstorage";
import getCosUploading from "./cos.config";


const token =  localStorage.getItem('token')
const fileTypes = {
    videoType: ['.mp4', '.mrv', '.mov', '.mpg', '.mpeg', '.ts', '.swf', '.flv', '.wmv', '.avi', '.mkv'],
    audioType: ['.aac', '.flac', '.ogg', '.ape', '.wav', '.mp3', '.wma'],
    docType: ['.pdf', '.xls', '.xlsx','.ppt','.pptx','.doc','.docx','.txt','.wps','.wpss','.docm','.dotm','.dot','.dotx','.html','pot','potx','pps','ppsx','dps','dpt','pptm','potm','ppsm','dpss'],
    imageType: ['.jpg', '.jpeg', '.png', '.gif'],

};
export function isTimestampExpired(expireTime) {
    // 将当前时间转换为秒（因为 expireTime 是以秒为单位的）
    const currentTimeInSeconds = Math.floor(Date.now() / 1000) + 60
    // 比较当前时间和过期时间
    if(currentTimeInSeconds >= Number(expireTime)){
        return true;
    }

}

export const fileTypeList = ['mp4', 'mrv', 'pdf', 'mov', 'mpg', 'aac', 'flac', 'ogg',
    'jpg', 'jpeg', 'png', 'gif', 'ape', 'ts', 'ppt', 'pptx', 'xls', 'xlsx', 'doc',
    'docx', 'txt', 'wav', 'mp3', 'wma', 'swf', 'flv', 'wmv', 'avi', 'mkv', 'wps',
    'wpss', 'docm', 'dotm', 'dot', 'dotx', 'html', 'pot', 'potx', 'pps', 'ppsx',
    'dps', 'dpt', 'pptm', 'potm', 'ppsm', 'dpss', 'mpeg']

export function decode(data) {
    try {
        var key = '79697368656e67746563686e6f6c6f6779636f6d70616e793230313930343131'
        key = CryptoJS.enc.Hex.parse(key)
        let iv = CryptoJS.enc.Hex.parse('79697368656e67746563684032303139')
        /*    console.log(key);
            console.log(iv);*/

        var dec = CryptoJS.AES.decrypt(CryptoJS.format.Hex.parse(data.data), key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        })

        return JSON.parse(CryptoJS.enc.Utf8.stringify(dec))
    } catch (e) {
        console.warn(e)
    }
    return ''
}
export function getFileSuffix(name) {
    let suffix = name.split(".")
    return suffix[suffix.length - 1]

}
//uuid
function  generateUUID() {
    const id = nanoid()
    return id
}
//生成随机路径和名称
export function generateFilePath(fileType,typeUpload) {
    // 获取当前日期
    const now = new Date();
    // 获取年、月、日，并确保月和日格式始终是两位数
    const year = now.getFullYear();
    const month = (now.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的
    const day = now.getDate().toString().padStart(2, '0');
    const randomChars = generateUUID().replace(/-/g, ''); // 使用之前的generateUUID函数，并去除破折号
    // 构建文件名
    const fileName = `${randomChars}${fileType}`;
    // 拼接完整的路径
    const dir = getLocalStorageForUser(token,'pathPrefix')?getLocalStorageForUser(token,'pathPrefix') : 'public'
    const filePath = `${dir}/${typeUpload}/${year}/${month}/${day}/${fileName}`;
    return filePath;
}


// 处理文件分类
export function classifyFileTypes(extension) {
    if (fileTypes.videoType.includes(extension)) {
        return 'video';
    } else if (fileTypes.audioType.includes(extension)) {
        return 'audio';
    } else if (fileTypes.docType.includes(extension)) {
        return 'doc';
    } else if (fileTypes.imageType.includes(extension)) {
        return 'image';
    }
}

export  async function  handleUploadFile($ajax,uploadType) {
    const checkAndUpdateCredentials = async () => {
        const uploadService = uploadType === 1 ? 'cosExpireTime' : (uploadType=== 2 ? 'ossExpireTime' : '');
        const expireTime = getLocalStorageForUser(token,uploadService)
        const currentTimeInSeconds = Math.floor(Date.now()/1000) + 60

        console.log('expireTime：',expireTime,'currentTimeInSeconds',currentTimeInSeconds,isTimestampExpired(expireTime));
        if (expireTime === 'undefined' || isTimestampExpired(expireTime)) {
            try {
                const res = await $ajax({
                    url: '/etv/getUploadCredential.json',
                    method: 'post',
                    headers: {
                        'token': token,
                    },
                })
                const data = decode(res.data)

                if (res.data.code && res.data.code == 1) {
                    Toast(res.data.msg)
                    return
                } else if (data !== null) {
                    if (uploadType === 1) {
                        const keys = [
                            "bucketName",
                            "region",
                            "tmpSecretId",
                            "tmpSecretKey",
                            "sessionToken",
                            "expireTime",
                            "pathPrefix"
                        ];

                        keys.forEach(key => {
                            removeLocalStorageForUser(token, key);
                        });

                        keys.forEach(key => {
                            if (data[key] !== undefined) {
                                const storageKey = key === "expireTime" ? "cosExpireTime" : key;
                                setLocalStorageForUser(token, storageKey, data[key]);
                            }
                        });

                        getCosUploading(true);
                    } else if (uploadType === 2) {
                        const keys = [
                            "dir",
                            "expireTime",
                            "host",
                            "policy",
                            "security_token",
                            "signature",
                            "version",
                            "x_oss_credential",
                            "x_oss_date",
                            "pathPrefix"
                        ];

                        keys.forEach(key => {
                            removeLocalStorageForUser(token, key);
                        });

                        keys.forEach(key => {
                            if (data[key] !== undefined) {
                                const storageKey = key === "expireTime" ? "ossExpireTime" : key;
                                setLocalStorageForUser(token, storageKey, data[key]);
                            }
                });
                }

                }

            } catch (error) {
                console.error("Failed to get new credentials", error)
                throw error
            }
        }
    };
    await checkAndUpdateCredentials()
}
/**
 * 上传cos
 * @param file
 * @param index
 */
export function uploadMaterialCOS(file,id,$ajax,uploadType, onProgress) {
    return new Promise((resolve, reject) => {
        // 源文件
        const suffix = getFileSuffix(file.name)
        let type = '.' + suffix.toLowerCase()
        let typeUpload = classifyFileTypes(type)
        let primaryName = generateFilePath(type, typeUpload)

        const uploadStatus = {
            complete: 0,
            success: false,
            taskId: null
        }

        const cosUploader = getCosUploading();

        cosUploader.uploadFile(`${primaryName}`, file,
            (progressData) => {
                // 更新进度
                uploadStatus.complete = Math.floor(progressData.percent * 100);
                // 获取当前的 taskId
                if (cosUploader.taskId) {
                    uploadStatus.taskId = cosUploader.taskId;
                }
                // 通过回调函数通知进度更新
                if (onProgress) {
                    onProgress(uploadStatus);
                }
            },
            (err) => {
                if (err !== null) {

                    reject(err);
                }
            },
            (err, data) => {

                if (err === null) {
                    let cosUrl = data.Location; // COS返回的视频URL
                    $ajax({//查询在线设备离线设备等
                        url: '/etv/createMaterial.json',
                        method: 'post',
                        headers: {
                            'Content-Type': 'application/json',
                            'token': localStorage.getItem('token'),
                        },
                        data: JSON.stringify({
                            "mtUrl": cosUrl,
                            "thumbnailUrl": "",
                            "mtSize": file.size,
                            "mtMfId": id,
                            "mtOgnName": file.name,
                            'uploadType':uploadType
                        }),
                    }).then(res => {
                        if (res.data.code === 0) {
                            Toast(res.data.msg)
                            uploadStatus.success = true
                            resolve(uploadStatus)
                        } else {
                            Toast(res.data.msg || '上传失败')
                            uploadStatus.success = false
                            resolve(uploadStatus)
                        }
                    })
                } else {
                    reject(err);
                }
            }
        )
    })
}
/**
 * 上传OSS
 * @param file
 * @param id
 * @param $ajax
 * @param uploadType
 * @param onProgress
 */
export function uploadMaterialOSS(file, id, $ajax, uploadType, onProgress) {
    return new Promise(async (resolve, reject) => {
        // 源文件
        const suffix = getFileSuffix(file.name)
        let type = '.' + suffix.toLowerCase()
        let typeUpload = classifyFileTypes(type)
        let primaryName = generateFilePath(type, typeUpload)

        const uploadStatus = {
            complete: 0,
            success: false,
            taskId: null
        }

        // 生成唯一的任务ID
        const taskId = 'oss_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        uploadStatus.taskId = taskId;

        // 立即通知 taskId
        if (onProgress) {
            onProgress(uploadStatus);
        }

        let formData = new FormData();
        formData.append("success_action_status", "200");
        formData.append("policy", getLocalStorageForUser(token, 'policy'))
        formData.append("x-oss-signature", getLocalStorageForUser(token, 'signature'))
        formData.append("x-oss-signature-version", getLocalStorageForUser(token, 'version'))
        formData.append("x-oss-credential", getLocalStorageForUser(token, 'x_oss_credential'))
        formData.append("x-oss-date", getLocalStorageForUser(token, 'x_oss_date'))
        formData.append("key", primaryName); // 文件名
        formData.append("x-oss-security-token", getLocalStorageForUser(token, 'security_token'))
        formData.append("file", file); // file 必须为最后一个表单域

        // 创建取消令牌
        const cancelToken = axios.CancelToken
        const source = cancelToken.source()

        // 将取消源存储到全局，以便取消时使用
        if (typeof window !== 'undefined') {
            window.currentOSSUploadSource = source;
        }

        try {
            const uploadResult = await $ajax({
                url: getLocalStorageForUser(token, 'host'),
                method: 'post',
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
                cancelToken: source.token,
                onUploadProgress: (progressEvent) => {
                    // 计算上传进度
                    const complete = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
                    uploadStatus.complete = complete;

                    // 通过回调函数通知进度更新
                    if (onProgress) {
                        onProgress(uploadStatus);
                    }
                }
            });

            if (uploadResult.status === 200) {
                let ossUrl = getLocalStorageForUser(token, 'host') + primaryName

                $ajax({//查询在线设备离线设备等
                    url: '/etv/createMaterial.json',
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        'token': token,
                    },
                    data: JSON.stringify({
                        "mtUrl": ossUrl,
                        "thumbnailUrl": "",
                        "mtSize": file.size,
                        "mtMfId": id,
                        "mtOgnName": file.name,
                        'uploadType': uploadType
                        }),
                    }).then(res => {
                        if (res.data.code === 0) {
                            Toast(res.data.msg)
                            uploadStatus.success = true
                            resolve(uploadStatus)

                        } else {
                        Toast(res.data.msg)
                        uploadStatus.success = false
                        resolve(uploadStatus)
                        }
                    })
            } else {
                reject(new Error('OSS上传失败'))
            }

        } catch (error) {
            if (axios.isCancel(error)) {

                reject(new Error('上传已取消'));
            } else {
                console.error('OSS上传过程中出错:', error);
                reject(error);
                }

        } finally {
            // 清理全局引用
            if (typeof window !== 'undefined') {
                window.currentOSSUploadSource = null;
            }
        }
    })
}
